    let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
    let dropdownItems = document.querySelector(".header__submenu");
    items.forEach(item => {
    item.addEventListener("click", () => {
        items.forEach(otherItem => {
        if (otherItem !== item) {
            otherItem.removeAttribute("open");
        }
        });
        item.setAttribute("open");
    });

    item.addEventListener("blur", () => {
        item.removeAttribute("open");
    });
    item.addEventListener("click", () => {
        item.setAttribute("open");
        });

    let itemContent = item.children[1].addEventListener("mouseleave", () => {
        item.removeAttribute("open");
    });
    });

    if (dropdownItems !== null) {
    dropdownItems.addEventListener("mouseleave", () => {
        items.forEach(item => {
        item.removeAttribute("open");
        });
    });
    }

// hidden announcement-bar
const menuDrawer = document.querySelector('details.menu-drawer-container');
// Seleccionamos el announcement bar
const announcementBar = document.querySelector('.scrolling-banner');

// Agregamos un event listener para detectar cuando se abre o cierra el details
menuDrawer.addEventListener('toggle', function() {
  // Si el details está abierto (tiene el atributo open)
  if (this.hasAttribute('open')) {
    announcementBar.style.display = 'none';
  } else {
    // Cuando se cierra, volvemos a mostrar el announcement bar
    announcementBar.style.display = 'flex';
  }
});